import { defineComponent, computed } from '@vue/composition-api';
import __vue_component__ from '../SdsIcon/SdsIcon.vue.js';
import __vue_component__$1 from './SdsTabBadge.vue.js';
import { useTabsContext } from './SdsTabsContext.js';

var script = defineComponent({
    name: 'SdsTabItem',
    props: {
        label: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        iconName: {
            type: String,
            required: false,
            default: undefined,
        },
        badgeText: {
            type: String,
            required: false,
            default: undefined,
        },
        isIconThemed: {
            type: Boolean,
            required: false,
            default: false,
        },
        hasIndicator: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    setup: function (props) {
        var _a = useTabsContext(), value = _a.value, background = _a.background, setValue = _a.setValue, handleKeyboardNavigation = _a.handleKeyboardNavigation;
        var isActive = computed(function () { return value.value === props.value; });
        return {
            isActive: isActive,
            background: background,
            setValue: setValue,
            handleKeyboardNavigation: handleKeyboardNavigation,
        };
    },
    components: {
        SdsIcon: __vue_component__,
        SdsTabBadge: __vue_component__$1
    },
});

export default script;
